module.exports = __webpack_public_path__ + "static/media/ClockCircle.f6c0d3f8.svg";